import { useMutation } from 'react-query';

import { postUserAuthenticationFactor } from '../api/postUserAuthenticationFactor';

export const usePostUserAuthenticationFactor = ({ name }: { name: string }) => {
  return useMutation(['createUserAuthenticationFactor'], () =>
    postUserAuthenticationFactor({ name }),
  );
};
